export function normalizeUrl(url) {
    if (!url) return '';
    if (url.startsWith("/")) return url;
    return `/${url}`;
}
